<template>
    <mdb-select
      :multiple="true"
      v-if="loadReady"
      v-on:getValue="getSelectValue"
      :options="labelOptions"
      :visibleOptions="4"
      icon="list"
      :label="$t('notification_group')"
      :placeholder="$t('choose_group')"
    />
  </template>
  
  <script>
  import { mdbSelect } from "mdbvue";
  export default {
    name: "Categories",
    components: {
      mdbSelect
    },
    props: {
      notificationGroupId: Number,
      notificationGroupsId: String
    },
    data() {
      return {
        loadReady: true,
        groups: [
          {
            displayname: "Ryhmä 1", 
            id: 1
          },
          {
            displayname: "Ryhmä 2", 
            id: 2
          },
          {
            displayname: "Ryhmä 3", 
            id: 3
          },
          {
            displayname: "Ryhmä 4", 
            id: 4
          }
        ],
        labelOptions: [],
      };
    },
    methods: {
      checkCategoryId() {
        this.labelOptions = [];
        var defaultSelection;
        if (this.notificationGroupsId !== null && this.notificationGroupsId !== undefined) {
          defaultSelection = this.notificationGroupsId.split(",")[0];
        } else {
          defaultSelection =
            this.notificationGroupId === 0 ? this.groups[0].id : this.notificationGroupId;
        }
        this.groups.forEach(function(group) {
          this.labelOptions.push({
            text: group.displayname,
            value: group.id,
            selected: this.getSelectedStatus(group, defaultSelection)
          });
        }, this);
      },
      getSelectedStatus(group, defaultSelection) {
        if (this.notificationGroupsId !== null && this.notificationGroupsId !== undefined) {
          return this.notificationGroupsId.split(",").includes(group.id.toString());
        } else {
          return defaultSelection === group.id ? true : false;
        }
      },
      getSelectValue(value, text) {
        this.$emit("groups", value, text);
      }
    },
    watch: {
      notificationGroupId: function(newVal, oldVal) {
        if (newVal !== 0 && this.groups !== null) {
          this.checkCategoryId();
        }
        console.log("Prop changed: ", newVal, " | was: ", oldVal);
      },
      notificationGroupsId: function(newVal, oldVal) {
        if (newVal !== undefined && this.groups !== null) {
          this.checkCategoryId();
        }
        console.log("Prop changed: ", newVal, " | was: ", oldVal);
      }
    },
    mounted() {
      this.checkCategoryId();
    }
  };
  </script>
  
  <style></style>
  